import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  },
  iframe: {
    flex: 1,
    border: 'none',
    width: '100%',
    height: '100%',
    minHeight: '600px',
  },
  centered: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: tokens.spacingVerticalM,
    height: '100%',
    padding: tokens.spacingVerticalXXL,
  },
});
